import { IonButton, IonCol, IonRow } from "@ionic/react";
import BasicPage from "../BasicPage/BasicPage";
import ItemWorkAside from "./ItemWorkAside";

interface Props {}

const WorkAside: React.FC<Props> = () => {
  const urlParams = new URLSearchParams(window.location.search);

  return (
    <BasicPage pathReturn>
      <IonRow className="ion-justify-content-end">
        <IonButton
          shape="round"
          fill="solid"
          color="secondary"
          strong
          onClick={() => {
            window.location.href =
              window.location.origin +
              window.location.pathname +
              "?type=" +
              (urlParams.get("type") === "tp" ? "td" : "tp");
          }}
        >
          Travaux {urlParams.get("type") === "tp" ? " dirigés" : "pratiques"}
        </IonButton>
      </IonRow>
      <IonRow className="ion-justify-content-center">
        <IonCol size-lg="8" size-sm="10" style={{ marginTop: "3vw" }}>
          <ItemWorkAside
            type={
              new URLSearchParams(window.location.search).get("type") ?? "tp"
            }
          />
        </IonCol>
      </IonRow>
    </BasicPage>
  );
};

export default WorkAside;
